import { useQuery } from "@apollo/client"
import { GET_ALL_TOURNAMENT_ROUNDS } from "../queries/allTournamentRounds"

export const useTournamentRounds = (tournamentId: number, showRounds = true) => {
  const options = {
    variables: {
      tournamentId,
      paginate: 999,
    },
    skip: !tournamentId || !showRounds,
  }
  const { data, loading, error, refetch } = useQuery(GET_ALL_TOURNAMENT_ROUNDS, options)

  return {
    rounds: showRounds ? data?.allTournamentRounds || [] : [], // 🔑 forzamos array vacío
    loading: showRounds ? loading : false,
    error: showRounds ? error : null,
    refetch: showRounds ? refetch : () => {}, // no hace nada si showRounds=false
  }
}
